export async function uploadFile (dir, file, onProgress, onSuccess, onError) {
  try {
    const OSS = require('ali-oss')
    const ossConfig = {
      // region以杭州为例（oss-cn-hangzhou），其他region按实际情况填写。
      region: 'oss-cn-shenzhen',
      // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
      accessKeyId: 'LTAIAcClE56I1mY0',
      accessKeySecret: 'IIPoiW0o3noCHU9bRT5vyAw0EDtem8',
      bucket: 'ihealthy',
      secure: true
    }
    const client = new OSS(ossConfig)

    const timestamp = Date.now()
    const random = Math.random().toString(36).substring(2, 10)
    const ext = file.name.lastIndexOf('.') !== -1 ? file.name.substring(file.name.lastIndexOf('.')) : ''
    const uniqueName = `${timestamp}_${random}${ext}`

    const ret = await client.multipartUpload(dir + '/' + uniqueName, file, {
      progress: async function (p) {
        // console.log('multipartUpload', p)
        const e = {}
        e.percent = parseInt(p * 100)
        onProgress(e.percent)
      }
    })

    if (ret.res.statusCode === 200) {
      var fileResp = ret.res.requestUrls[0]
      var fileUrl = fileResp.split('?')[0].replace(/^http:/, 'https:')
      onSuccess(fileUrl)
    } else {
      onError('上传失败')
      console.log('上传失败', ret)
    }
  } catch (err) {
    console.error('上传失败', err)
    onError('上传失败')
    // this.$error(err.message)
  }
}
